import { Component, OnInit } from '@angular/core';
import { PatientAllergyModel, PatientSocialHistoryModel, ItemList, AllergyListModel, Allergies, severtydropdownListt, DeleteAllergy, NoKnownHistory, IntakeFieldsSetting } from 'src/app/models/intake/intakeAllergies';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { IntakeAllergyService } from 'src/app/services/intake-Allergy.service';
import { IntakeService } from 'src/app/services/intake.service';
import { TranslateService } from '@ngx-translate/core';

var objectCopyAllergy: any;
declare var $: any;
@Component({
  selector: 'app-allergy',
  templateUrl: './allergy.component.html',
  styleUrls: ['./allergy.component.css']
})
export class AllergyComponent implements OnInit {
  objPatientAllergy: PatientAllergyModel[] = [];
  patientpersonalinfo: any;
  objPatientSocialHistory: PatientSocialHistoryModel = new PatientSocialHistoryModel();
  reactiondropdownList: ItemList[] = [];
  intakeFieldsSetting: IntakeFieldsSetting=new IntakeFieldsSetting();
  allergyaction:any="Add";
  curDate = new Date();
  
  reactiondropdownSettings = {
    singleSelection: false,
    idField: 'allergyReactionId',
    textField: 'allergyReactioNDescription',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableCheckAll: false,
    itemsShowLimit: 3,
    allowSearchFilter: false,
    reconcileAllergyId: 'reconcileAllergyId'
  };
  
  constructor(private translateService: TranslateService, private _phrutilService: PhrutillsService, private spinner: NgxSpinnerService, private _intakedService: IntakeAllergyService
    , private route: Router, private datepipe: DatePipe, private _intakeser: IntakeService) {
      let info = localStorage.getItem('PersonalInfo');
      if (!info) {
        this.route.navigateByUrl("/");
        return;
      }
    }
    
    ngOnInit(): void {
      this._phrutilService.patientlanguage$.subscribe(language => {
        console.log("dafault " + language);
        if (language === 'es') {
          this._phrutilService.setTitle('Alergias');
        } else if (language === 'hi') {
          this._phrutilService.setTitle('एलर्जी');
        }
        else if (language === 'ur') {
          this._phrutilService.setTitle('الرجی');
        } 
        else {
          this._phrutilService.setTitle('Allergies');
        }
      });
      this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PersonalInfo'));
      this.setIntakeDropDown();
      this.GetNoKnownHistory();
      this.translateService.get('button.add').subscribe((translation: string) => {
        this.allergyaction = translation;
      });
    }
    isLoadingPE = true;
    onPatientAllergy() {
      this.objPatientAllergy = [];
      this.isLoadingPE = true;
      this.spinner.show();
      this._intakedService.GetPatientAllergies(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE).subscribe((res: any) => {
        this.spinner.hide();
        this.isLoadingPE = false;
        if (res.statusCode == 200) {
          this.objPatientAllergy = res.data.patientAllergies as PatientAllergyModel[];
          this.objPatientAllergy.map(data => {
            data.resolvedDate = this.objPatientSocialHistory.tobaccoEndDate = this.datepipe.transform(data.resolvedDate, 'yyyy-MM-dd');
            data.onsetDate = this.objPatientSocialHistory.tobaccoEndDate = this.datepipe.transform(data.onsetDate, 'yyyy-MM-dd');
            data.allergyReactions = this.setReactionIdAndDescription(data.allergyReactionDescriptionWithIds);
            if (data.allergySeverityId == "0") {
              data.allergySeverityId = "";
            }
          });
          
          this.objPatientAllergy.map(dataTemp => {
            dataTemp.allergyReactions.map(reactionTemp => {
              let Allergy_TEMP = this.reactiondropdownList.find(data => data.allergyReactioNDescription == reactionTemp.allergyReactioNDescription);
              if (Allergy_TEMP) {
                reactionTemp.allergyReactionId = Allergy_TEMP.allergyReactionId;
              }
            })
            
            if (dataTemp.allergyReactionDescription) {
              let reactionDescription_TEMP = dataTemp.allergyReactionDescription.split(",");
              let strTemp = "";
              reactionDescription_TEMP.map((str: any, index: any) => {
                if (index == 0) {
                  strTemp = `${str}`;
                } else {
                  strTemp = `${strTemp}, ${str}`;
                }
              });
              dataTemp.allergyReactionDescription = strTemp.substr(0, strTemp.length - 2);
            }
            
          });
          this.GetIntakeformFieldsSettings();
        } else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
        
      },
      (error: any) => {
        
        this.spinner.hide();
        this.isLoadingPE = false;
        if (error.includes('404')) {
        } else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      });
    }
    setReactionIdAndDescription(strReactions: string) {
      
      let reactionsObj: ItemList[] = [];
      
      if (strReactions.includes(",")) {
        
        let reactionsData = strReactions.split(",");
        reactionsData.map(data => {
          if (data) {
            reactionsObj.push({
              allergyReactionId: data.split("|")[0],
              allergyReactioNDescription: data.split("|")[1],
              reconcileAllergyId: ""
            });
          }
        });
        
      } else {
        if (strReactions.length > 0) {
          reactionsObj.push({
            allergyReactionId: strReactions.split("|")[0],
            allergyReactioNDescription: strReactions.split("|")[1],
            reconcileAllergyId: ""
          });
        }
      }
      
      return reactionsObj;
      
    }
    allergyError: string;
    filteredAllergyies: AllergyListModel[] = [];
    startDateError = "";
    wordCounter: any = 0;
    readonly operationEdit = "EDIT";
    selected_objPatientAllergy: PatientAllergyModel = new PatientAllergyModel();
    selectedReactionsDropDownList: ItemList[] = [];
    onModalAllergy(operation: string, selectedOBJ?: any) {
      
      this.allergyError = "";
      this.startDateError = "";
      this.wordCounter = 0;
      this.filteredAllergyies = [];
      
      if (operation == this.operationEdit) {
        this.selected_objPatientAllergy = selectedOBJ;
        this.selectedReactionsDropDownList = JSON.parse(JSON.stringify(this.selected_objPatientAllergy.allergyReactions));
        this.translateService.get('button.update').subscribe((translation: string) => {
          this.allergyaction = translation;
        });
       // this.allergyaction="Update";
      } else {
        this.translateService.get('button.add').subscribe((translation: string) => {
          this.allergyaction = translation;
        });
        //this.allergyaction="New";
        this.selected_objPatientAllergy = new PatientAllergyModel();
        this.selected_objPatientAllergy.allergyTypeId = "1";
        this.selected_objPatientAllergy.allergyType = "MEDICINE";
        this.selected_objPatientAllergy.allergyReactions = [];
        this.selectedReactionsDropDownList = [];
      }
      
      this.operationPerformed = operation;
      $("#Allergy-Modal").modal("show");
  }
  isFromSaveMore: boolean = false;
  AddanotherAllergy() {
    this.isFromSaveMore = true;
    this.OnAllergySubmit();
    //this.onModalAllergy('operationAdd')
    //$("#Allergy-Modal").modal("show");
    //this.onSaveAllergy();
    this.selected_objPatientAllergy.allergyDescription = "";
    this.selected_objPatientAllergy.allergySeverityId = "";
    this.selectedReactionsDropDownList = [];
    //$("#addMore-allergy").modal("hide");
  }
  onlysaveAllergy() {
    this.isFromSaveMore = false;
    this.OnAllergySubmit();
  }
  CloseAllergyModal() {
    this.onSaveAllergy();
    $("#addMore-allergy").modal("hide");
    $("#Allergy-Modal").modal("hide");
  }
    endDateError = "";
    OnAllergySubmit() {
     
      if (!this.selected_objPatientAllergy.allergyDescription) {
        this.translateService.get('allergy.allergy_error_select_allergy').subscribe((translation: string) => {
          this.allergyError = translation;
        });
        //this.allergyError = "Please select allergy from search dropdown.";
        return;
      }
      
      if (!this.selected_objPatientAllergy.allergyCode) {
        this.translateService.get('allergy.allergy_error_select_correct_allergy').subscribe((translation: string) => {
          this.allergyError = translation;
        });
        //this.allergyError = "Please select correct allergy from search dropdown.";
        return;
      }
      
      
      if (!this.selected_objPatientAllergy.allergySeverityId) {
        this.selected_objPatientAllergy.allergySeverityId = "";
        // this.severityError = "Please select severity.";
        // return;
      }
      
      // if (this.selected_objPatientAllergy.allergySeverityId == "0" || this.selected_objPatientAllergy.allergySeverity == "") {
      //   this.severityError = "Please select severity.";
      //   return;
      // }
      
      
      if (!this.selectedReactionsDropDownList) {
        this.selectedReactionsDropDownList = [];
        // this.reactionError = "Please select reaction.";
        // return;
      }
      
      // if (this.selectedReactionsDropDownList.length == 0) {
      //   this.reactionError = "Please select reaction.";
      //   return;
      // }
      
      this.startDateError = "";
      if (!this.selected_objPatientAllergy.onsetDate) {
        this.selected_objPatientAllergy.onsetDate = "";
        // this.startDateError = "Please provide observation date.";
        // return;
      }
      
      this.endDateError = "";
      if (!this.selected_objPatientAllergy.resolvedDate) {
        this.selected_objPatientAllergy.resolvedDate = "";
        // this.endDateError = "Please provide end date.";
        // return;
      }
      if(this.isDateError)
      {
        return;
      }
      if (this.selected_objPatientAllergy.onsetDate) {
        if (this.selected_objPatientAllergy.resolvedDate) {
          if (this.selected_objPatientAllergy.onsetDate == this.selected_objPatientAllergy.resolvedDate) {
            this.startDateError = "Observation date must be prior to the end date";
            return;
          }
          
          if (this.selected_objPatientAllergy.onsetDate > this.selected_objPatientAllergy.resolvedDate) {
            this.startDateError = "Observation date must be prior to the end date";
            return;
          }
        }
      }
      
      if (!this.selected_objPatientAllergy.comments) {
        this.selected_objPatientAllergy.comments = "";
      }
      
      this.selected_objPatientAllergy.allergyReactions = this.selectedReactionsDropDownList as ItemList[];
      
      this.selected_objPatientAllergy.allergyReactions.map((objAllergy: any) => {
        let Allergy_TEMP = this.reactiondropdownList.find(data => data.allergyReactioNDescription == objAllergy.allergyReactioNDescription);
        if (Allergy_TEMP) {
          objAllergy.allergyReactionId = Allergy_TEMP.allergyReactionId;
        }
      });
    
      //$("#addMore-allergy").modal("show");
      this.onSaveAllergy();
    }
    readonly _IP_Address = "127.0.0.1";
    operationPerformed = "";
    readonly operationAdd = "ADD";
    onSaveAllergy() {
      
      let objPatientAllergy_Save: Allergies = new Allergies();
      objPatientAllergy_Save.allergyReactions = [];
      
      objPatientAllergy_Save.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT.toString();
      objPatientAllergy_Save.practiceCode = this.patientpersonalinfo.PRACTICE_CODE.toString();
      objPatientAllergy_Save.allergyCode = this.selected_objPatientAllergy.allergyCode;
      objPatientAllergy_Save.allergyDescription = this.selected_objPatientAllergy.allergyDescription;
      objPatientAllergy_Save.comments = this.selected_objPatientAllergy.comments;
      objPatientAllergy_Save.allergySeverityId = this.selected_objPatientAllergy.allergySeverityId;
      objPatientAllergy_Save.allergyTypeId = this.selected_objPatientAllergy.allergyTypeId;
      objPatientAllergy_Save.allergyTyepIdUnSnomed = "";
      objPatientAllergy_Save.ipAddress = this._IP_Address;
      objPatientAllergy_Save.reactionId = ""//this.selected_objPatientAllergy.allergyReactionId;
      objPatientAllergy_Save.reactionDescription = "";//this.selected_objPatientAllergy.allergyReactionDescription;
      objPatientAllergy_Save.startDate = this.selected_objPatientAllergy.onsetDate;
      objPatientAllergy_Save.endDate = this.selected_objPatientAllergy.resolvedDate;
      objPatientAllergy_Save.allergyReactions = this.selected_objPatientAllergy.allergyReactions;
      objPatientAllergy_Save.validUserID = "";
      objPatientAllergy_Save.allergyId = this.selected_objPatientAllergy.patientAllergyId;
      let lang = localStorage.getItem('language');
      if (!lang)
        lang = 'en';
      this.translateService.use(lang);
      objPatientAllergy_Save.language = lang;
      if (objPatientAllergy_Save.allergyId === '') {
        objPatientAllergy_Save.allergyId = null
      }
      
      this.spinner.show();
      this._intakedService.SavePatientAllergie(objPatientAllergy_Save).subscribe((res: any) => {
        this.spinner.hide();
        if (res.statusCode == 200) {
          if (this.operationPerformed == this.operationAdd) {
            let text = "Allergy saved successfully";
            this.translateService.get('Alerts.allergy_saved').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showSuccess(text);
            //this._phrutilService.showSuccess("Allergy saved successfully");
          } else {
            let text = "Allergy updated successfully";
            this.translateService.get('Alerts.allergy_updated').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showSuccess(text);
            //this._phrutilService.showSuccess("Allergy updated successfully");
          }
          if (this.isFromSaveMore) {
            this.onModalAllergy('operationAdd')
          } else {
            $("#Allergy-Modal").modal("hide");
          }
          
          this.onPatientAllergy();
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      });
    }
    isLoading = false;
    dNoneallergy:boolean=true;
    GetSolarApiAllergies(event: any) {
      
      this.filteredAllergyies = [];
      if (event.keyCode == 40 || event.keyCode == 39 || event.keyCode == 38 || event.keyCode == 37) {
        return;
      }
      
      this.allergyError = "";
      
      if (this.selected_objPatientAllergy.allergyDescription == "" || this.selected_objPatientAllergy.allergyDescription.length <= 2) {
        this.selected_objPatientAllergy.allergyCode = "";
        this.filteredAllergyies = [];
        this.dNoneallergy=true;
        return;
      }
      
      this.isLoading = true;
      this.dNoneallergy=false;
      this._intakedService.GetSolarApiAllergies(this.selected_objPatientAllergy.allergyDescription, this.selected_objPatientAllergy.allergyType, this.patientpersonalinfo.PRACTICE_CODE.toString()).subscribe((data: any) => {
        if (data) {
          this.isLoading = false;
          if (data.numFound == "0") {
            this.filteredAllergyies = [];
          } else {
            this.filteredAllergyies = data.response.docs as AllergyListModel[];
            this.filteredAllergyies.map(dataTemp => {
              dataTemp.DESCRIPTION = this.convertToTitleCase( dataTemp.DESCRIPTION.replace("[Free Text]", "") );
            });

            objectCopyAllergy = this.filteredAllergyies;
          }
        }
      });
  }
  convertToTitleCase(text: string): string {
    if (!text) return text;

    return text.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  clearAllergyInput() {
    this.selected_objPatientAllergy.allergyDescription = '';
  }
    SetAllergies(item: any) {
      if (item) {
        this.allergyError = "";
        var all = objectCopyAllergy.filter((x: any) => x.DESCRIPTION.toLowerCase() == item.toLowerCase());
        if (all != undefined && all != null && all.length > 0) {
          this.selected_objPatientAllergy.allergyDescription = all[0].DESCRIPTION;
          this.selected_objPatientAllergy.allergyCode = all[0].ALLERGY_CODE;
        }
      }
  }




    onDeleteAllergy(selectedAllergy: PatientAllergyModel) {
      this.selected_objPatientAllergy = new PatientAllergyModel();
      this.selected_objPatientAllergy = { ...selectedAllergy };
      $("#delete-allergy").modal("show");
    }
    onSetAllergyType(typeDescription: string, typeId: string) {
      
      if (this.selected_objPatientAllergy.allergyTypeId != typeId) {
        this.selected_objPatientAllergy.allergyCode = "";
        this.selected_objPatientAllergy.allergyDescription = "";
        this.filteredAllergyies = [];
      }
      
      this.selected_objPatientAllergy.allergyType = typeDescription;
      this.selected_objPatientAllergy.allergyTypeId = typeId;
    }
    severityError = "";
    severtydropdownList: any = [];
    severtydropdownListt: severtydropdownListt;
    onChangeSeverity() {
      this.severityError = "";
    }
    PMH_Temp: any = [];
    itemList: ItemList = new ItemList();
    setIntakeDropDown() {
      this.spinner.show();
      this._intakedService.GetIntakeDropDownList(this.patientpersonalinfo.PRACTICE_CODE, this.patientpersonalinfo.PATIENT_ACCOUNT).subscribe((res: any) => {
        this.spinner.hide();
        if (res.statusCode == 200) {
          
          for (let i = 0; i < res.data.pastMedicalHistories.length; i++) {
            this.PMH_Temp.push(res.data.pastMedicalHistories[i])
          }
          
          for (let item of res.data.predefinedForms) {
            if (item.frontLabel == 'Reaction') {
              let reactionList = item.options;
              let reactions = reactionList.split(",");
              for (let item of reactions) {
                let splitResult = item.split("|");
                this.itemList = new ItemList();
                this.itemList.allergyReactionId = splitResult[0];
                this.itemList.allergyReactioNDescription = splitResult[1];
                if (this.itemList.allergyReactionId != '') {
                  this.reactiondropdownList.push(this.itemList);
                }
              }
              this.reactiondropdownList = JSON.parse(JSON.stringify(this.reactiondropdownList));
            } else if (item.frontLabel == 'Severity') {
              let severityList = item.options;
              let severityResult = severityList.split(",");
              for (let item of severityResult) {
                let splitResult = item.split("|");
                this.severtydropdownListt = new severtydropdownListt();
                this.severtydropdownListt.value = splitResult[0]
                this.severtydropdownListt.text = splitResult[1]
                if (this.severtydropdownListt.value != '') {
                  this.severtydropdownList.push(this.severtydropdownListt);
                }
              }
            }
            
          }
        } else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError('Service is not available, please try later.');
        }
        
        this.onPatientAllergy();
      },
      (error: any) => {
        this.spinner.hide();
        //this._phrutilService.showError('Service is not available, please try later.');
        this.onPatientAllergy();
      });
    }
    reactionError: any = "";
    onChangeReaction() {
      this.reactionError = "";
    }
    onAllergyDateChange() {
      this.startDateError = "";
      this.endDateError = "";
    }
    CheckLength(feedbackText: string) {
      this.wordCounter = feedbackText.trim().length;
    }
    onConfirmDeleteAllergy() {
      this.spinner.show();
      if (!this.selected_objPatientAllergy.patientAllergyId) {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
        this.spinner.hide();
        return;
      }
      
      let objDeleteAllergy = new DeleteAllergy();
      objDeleteAllergy.allergyId = this.selected_objPatientAllergy.patientAllergyId;
      objDeleteAllergy.practiceCode = this.patientpersonalinfo.PRACTICE_CODE.toString();
      objDeleteAllergy.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT.toString();
      objDeleteAllergy.modifiedBy = this.patientpersonalinfo.PATIENT_ACCOUNT.toString();
      objDeleteAllergy.deleted = true;
      
      this._intakedService.DeletePatientAllergie(objDeleteAllergy).subscribe((res: any) => {
        $("#delete-allergy").modal("hide");
        this.spinner.hide();
        if (res.statusCode == 200) {
          let text = "Allergy deleted successfully";
          this.translateService.get('Alerts.allergy_deleted').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showSuccess(text);
         // this._phrutilService.showSuccess("Allergy deleted successfully");
          this.onPatientAllergy();
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
         // this._phrutilService.showError("Service is not available, please try later.");
        }
        this.spinner.hide("deletePatientAllergy");
      },
        (error: any) => {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
        $("#delete-allergy").modal("hide");
        this.spinner.hide();
      });
    }
    noKnownDate: any;
    NoKnownHistory: any;
    setNoKnownAlrgMedFam(type: any) {
      
      this.noKnownDate = '';
      
      if (type === 'allergy') {
        
        if (this.NoKnownHistory[0].nO_KNOWN_ALLERGY === 'False' || this.NoKnownHistory[0].nO_KNOWN_ALLERGY == null || this.NoKnownHistory[0].nO_KNOWN_ALLERGY == undefined) {
          
          this.noKnownDate = 'Known Allergy';
          this.SaveIntakeNoknownValues(1);
        }
        else {
          let text = "Allergy is already set noknown";
          this.translateService.get('Alerts.allergy_is_alreadyset_noknown').subscribe((translation: string) => {
            text = translation;
          });
          //this._phrutilService.showInfo(text);
         // this._phrutilService.showInfo('Allergy is already set noknown');
          this._intakeser.onNoKnown();
        }
      }
    }
    SaveIntakeNoknownValues(type: any) {
      
      this.spinner.show();
      
      this._intakedService.SaveIntakeNoknownValues(type, this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE).subscribe((res: any) => {
        this.spinner.hide();
        if (res.statusCode == 200) {
          let text = "NoKnown Allergy is set";
          this.translateService.get('Alerts.noknown_allergy_is_set').subscribe((translation: string) => {
            text = translation;
          });
          //this._phrutilService.showInfo(text);
          //this._phrutilService.showInfo('NoKnown Allergy is set');
          this._intakeser.onNoKnown();
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      }, (error: any) => {
        
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
       // this._phrutilService.showError("Service is not available, please try later.");
        
      });
    }
    GetNoKnownHistory() {
      this._intakedService.GetNoKnownHistory(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE).subscribe((res: any) => {
        
        if (res.statusCode == 200) {
          this.NoKnownHistory = res.data;
          
        }
      }, (error: any) => {
        
      });
    }
    GetIntakeformFieldsSettings() {
      
      this.intakeFieldsSetting = this._phrutilService.decrypt(localStorage.getItem("intakeformsetting"));
    }
    onAllergyProvider(data: any) {
      if (data == 'edit') {
        let text = "You can't edit allergies added by provider";
        this.translateService.get('Alerts.cannot_edit_allergy_by_provider').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("You can't edit allergies added by provider");
      }
      else if (data == 'delete') {
        let text = "You can't delete allergies added by provider";
        this.translateService.get('Alerts.cannot_delete_allergy_by_provider').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("You can't delete allergies added by provider");
      }
    }
    isDateError: boolean = false;
    onChangeDate(e: any){
      let d: Date = new Date(e.target.value);
      let curD: Date = new Date(this.curDate);
      if (d > curD) {
        this.isDateError = true;
      } else {
        this.isDateError = false;
      }
    }
  }
